module.exports = __webpack_public_path__ + "static/don19-edcebe3acc844e4bb9f4333b2cd20e6c.jpg";